import { useId } from "react";

const useUniqueId = (): string => {
  const id = useId();
  return `unique-${id.replace(/[^a-zA-Z0-9-_]/g, "")}`;
};

export default useUniqueId;
